// src/pages/ItemLedger/ItemLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getItemLedgerApi } from "../../apiservice/inventory";

export const fetchItemLedger = createAsyncThunk(
  "itemLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        itemId: filters?.itemId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getItemLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
